import {
  countries as countriesData,
  timeZone,
} from "../../../resources/LocationData";
import { useEffect, useState } from "react";
import Styles from "./locationStyle.module.css";
import { toast, ToastContainer } from "react-toastify";
import { MdOutlineEditLocationAlt } from "react-icons/md";
import AddressForm from "../Components/AddressForm";
import {
  Select,
  Button,
  Form,
  Input,
  InputNumber,
  Checkbox,
} from "antd";
import { FaDownload } from "react-icons/fa6";
import jsPDF from 'jspdf';
import ReactDOM from 'react-dom';
import { svg2pdf } from 'svg2pdf.js';
import { QRCodeSVG } from 'qrcode.react';


const LocationDetailsComponent = ({ locationDetails, setlocationDetails, isApprover, approvalStage, siteStatus, setSiteStatus, isApproverView }) => {
  const { Option } = Select;
  const [form] = Form.useForm();
  const [countryOPtions, setCountryOptions] = useState([]);
  const [stateOptions, setStateOptions] = useState([]);
  const [cityOptions, setCityOptions] = useState([]);
  // const [timeZoneOptions, setTimeZoneOptions] = useState([]);
  // console.log("location details: ", locationDetails);
  useEffect(() => {
    setCountryOptions(Object.keys(countriesData));
    if (locationDetails.country) {
      setStateOptions(
        Object.keys(countriesData[locationDetails.country] || {})
      );
    }
    if (locationDetails.state) {
      setCityOptions(
        countriesData[locationDetails.country]?.[locationDetails.state] || []
      );
    }
  }, []);

  const submitForm = (isCompleted) => {
    if (isCompleted) {
      if (
        Object.values(locationDetails).filter((value) => value !== null)
          .length === Object.values(locationDetails).length
      ) {
        form.submit();
        setlocationDetails((prev) => ({
          ...prev,
          isSectionCompleted: true,
        }));
        // Submit the form
      } else {
        setlocationDetails((prev) => ({
          ...prev,
          isSectionCompleted: false,
        }));
        // Reset the checkbox in the form
        form.setFieldsValue({
          isSectionCompleted: false,
        });

        toast.error(
          "Please fill all the details before marking the section as completed."
        );
        //   setlocationDetails(prev => ({
        //     ...prev,
        //     isLocationSectionCompleted: false
        // }));
      }
    }
  };

  const handleAutoCompletionSelect = (details) => {
    // console.log("selected details from auto complete: ", details);
    setlocationDetails((prev) => ({
      ...prev,
      country: details.country || null,
      city: details.city || null,
      postalCode: details.postalCode || null,
      state: details.state || null,
      streetAndNumber: details.streetAndNumber || null,
    }));
    form.setFieldsValue({
      country: details.country || null,
      city: details.city || null,
      postalCode: details.postalCode || null,
      state: details.state || null,
      streetAndNumber: details.streetAndNumber || null,
    });

  }


  const handleCountryChange = (selectedCountry) => {
    setlocationDetails((prev) => ({
      ...prev,
      country: selectedCountry,
      state: null,
      city: null,
    }));
    setStateOptions(Object.keys(countriesData[selectedCountry] || {}));
    setCityOptions([]);
    // form.resetFields(['city']);
    // form.resetFields(['state']);
    form.setFieldsValue({
      state: null,
      city: null, // Explicitly set the city value to null/undefined/'' in the Form
    });
  };

  const handleStateChange = (selectedState) => {
    setlocationDetails((prev) => ({
      ...prev,
      state: selectedState,
      city: null,
    }));
    setCityOptions(
      countriesData[locationDetails.country]?.[selectedState] || []
    );
    form.setFieldsValue({
      state: selectedState,
      city: null, // Explicitly set the city value to null/undefined/'' in the Form
    });
  };

  const handleCityChange = (selectedCity) => {
    setlocationDetails((prev) => ({
      ...prev,
      city: selectedCity,
    }));
  };

  const downloadLocationCodeIDs = async (selectedLocationCodeId) => {
    try {
      // setIsDownloadQrCodesLoading(true);
      let qrData
      if (locationDetails.siteType === 'PUBLIC') {

        qrData = `${process.env.REACT_APP_BASE_URL}/registration`

      }
      else {

        qrData = `${process.env.REACT_APP_BASE_URL}/registration/loc/${selectedLocationCodeId}`

      }


      // Create a hidden container for rendering the QR code
      const container = document.createElement('div');
      container.style.position = 'absolute';
      container.style.left = '-9999px'; // Move off-screen
      document.body.appendChild(container);


      ReactDOM.render(
        <QRCodeSVG
          id="tempQrCodeSVG"
          value={qrData}
          size={190}
          bgColor="#ffffff"
          fgColor="#000000"
          level="H"
          //   includeMargin={true}
          renderAs='svg'
        />,
        container,
        async () => {
          try {
            await new Promise((resolve) => setTimeout(resolve, 500));



            const svgElement = document.getElementById('tempQrCodeSVG');

            if (!svgElement) {
              throw new Error('SVG element not found');
            }

            const pdfSize = 250;
            const margin = 30;
            const qrSize = pdfSize - 2 * margin;

            const pdf = new jsPDF({
              format: [pdfSize, pdfSize]
            });

            await svg2pdf(svgElement, pdf, { x: margin, y: margin, width: qrSize, height: qrSize });

            // Save the PDF
            pdf.save(`QR-${locationDetails?.name || 'Location'}-${selectedLocationCodeId}.pdf`);
          } finally {

            ReactDOM.unmountComponentAtNode(container);
            document.body.removeChild(container);
            // setIsDownloadQrCodesLoading(false);
          }
        }
      );
    } catch (error) {
      console.error(error.message);
      // setIsDownloadQrCodesLoading(false);
      toast.error('Something went wrong. Cannot download pdf for location code IDs');
    }
  };

  return (
    <div className={Styles[`main-div`]}>
      <div className={Styles["location-head-div"]}>
        <div>
          <p>
            Location Code:{" "}
            <span className={Styles["location-code"]}>
              {locationDetails?.codeID}{" "}
            </span>{" "}
            <Button
              onClick={() => { downloadLocationCodeIDs(locationDetails?.codeID) }}
              style={{ boxShadow: 'none', border: 'none' }}
              icon={<FaDownload />}
            />
          </p>
        </div>
        <div>
          <span>
            {" "}
            {locationDetails?.isSectionCompleted && isApprover && isApproverView && (
              <Button
                className={Styles["edit-btn"]}
                disabled={!locationDetails?.isSectionCompleted || siteStatus === "Live" || siteStatus === "Pre Live" || approvalStage !== 'PendingApproval'}
                onClick={() => {
                  setlocationDetails((prev) => ({
                    ...prev,
                    isSectionCompleted: false,
                  }));
                  form.setFieldsValue({
                    isSectionCompleted: false,
                  });
                }}
              >
                {" "}
                <MdOutlineEditLocationAlt
                  className={Styles["location-edit-icon"]}
                />{" "}
                Edit
              </Button>
            )}
          </span>
        </div>
      </div>

      <Form
        className={Styles["form-grid"]}
        form={form}
        initialValues={locationDetails}
        disabled={locationDetails?.isSectionCompleted || (approvalStage === "Approved") || (approvalStage === "PendingApproval" && isApprover === false)}
      >
        <Form.Item
          name="name"
          label="Location Name"
          rules={[{ required: true, message: "Please input location name!" }]}
        >
          <Input
            // value={locationDetails?.name}
            onChange={(e) => {
              setlocationDetails((prev) => ({
                ...prev,
                name: e.target.value,
              }));
            }}
          ></Input>
        </Form.Item>
        <Form.Item name="address" label="Location Address">
          <Input
            // value={locationDetails?.address}
            onChange={(e) => {
              setlocationDetails((prev) => ({
                ...prev,
                address: e.target.value,
              }));
            }}
          ></Input>
        </Form.Item>

        <Form.Item style={{ display: 'none' }} label="Address Lookup">
          <AddressForm handleAutoCompletionSelect={handleAutoCompletionSelect} locationAddress={locationDetails?.address} locationDetails={locationDetails} />
        </Form.Item>

        <Form.Item
          name="streetAndNumber"
          label="Street and Number"
          rules={[
            { required: true, message: "Please input street and number!" },
          ]}
        >
          <Input
            // value={locationDetails?.streetAndNumber}
            onChange={(e) => {
              setlocationDetails((prev) => ({
                ...prev,
                streetAndNumber: e.target.value,
              }));
            }}
          ></Input>
        </Form.Item>
        <Form.Item
          label="Country"
          name="country"
          rules={[{ required: true, message: "Please input country!" }]}
        >
          <Select
            // value={locationDetails?.country}
            onChange={handleCountryChange}
            placeholder="Select Country"
            allowClear
          >
            {countryOPtions.map((country) => (
              <Option key={country} value={country}>
                {country}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          label="State"
          name="state"
          rules={[{ required: true, message: "Please input state!" }]}
        >
          <Select
            // value={locationDetails.state}
            onChange={handleStateChange}
            placeholder="Select State"
            allowClear
            showSearch
          >
            {stateOptions.map((state) => (
              <Option key={state} value={state}>
                {state}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          label="City"
          name="city"
          rules={[{ required: true, message: "Please input city!" }]}
        >
          <Select
            // value={locationDetails.city}
            onChange={handleCityChange}
            placeholder="Select City"
            allowClear
            showSearch
          >
            {cityOptions.map((city) => (
              <Option key={city} value={city}>
                {city}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          name="postalCode"
          label="Postal Code"
          rules={[{ required: true, message: "Please input postal code!" }]}
        >
          <Input
            // value={locationDetails?.postalCode}
            onChange={(e) => {
              setlocationDetails((prev) => ({
                ...prev,
                postalCode: e.target.value,
              }));
            }}
          ></Input>
        </Form.Item>
        <Form.Item
          label="Timezone"
          name="timeZone"
          rules={[{ required: true, message: "Please select timezone!" }]}
        >
          <Select
            // value={locationDetails.timezone || undefined}
            onChange={(value) =>
              setlocationDetails((prev) => ({ ...prev, timeZone: value }))
            }
            placeholder="Select Time Zone"
            allowClear
            showSearch
          >
            {timeZone.map((zone) => (
              <Option
                key={zone.name}
                value={zone.name}
              >{`${zone.offset} ${zone.name}`}</Option>
            ))}
          </Select>
        </Form.Item>

        {/* country: selectedSite?.country || null,
        state: selectedSite?.state || null,
        city: selectedSite?.city || null, 
        timeZone: selectedSite?.timeZone || null,*/}

        <Form.Item
          label="Latitude"
          name="latitude"
          rules={[{ required: true, message: "Please select latitude!" }]}
        >
          <InputNumber
            placeholder={33.3907}
            min={0}
            // value={locationDetails?.latitude}
            onChange={(value) => {
              setlocationDetails((prev) => ({
                ...prev,
                latitude: value,
              }));
            }}
          />
        </Form.Item>
        <Form.Item
          label="Longitude"
          name="longitude"
          rules={[{ required: true, message: "Please select longitude!" }]}
        >
          <InputNumber
            placeholder={-111.9281}
            // min={0}
            // value={locationDetails?.longitude}
            onChange={(value) => {
              setlocationDetails((prev) => ({
                ...prev,
                longitude: value,
              }));
            }}
          />
        </Form.Item>
        <Form.Item
          label="Site Type"
          name="siteType"
          rules={[{ required: true, message: "Please select site type!" }]}
        >
          <Select
            onClick={(e) => e.stopPropagation()}
            // value={locationDetails?.siteType}
            onChange={(value) => {
              setlocationDetails((prev) => ({
                ...prev,
                siteType: value,
              }));
            }}
            placeholder="Select site type"
          >
            <Select.Option value="PUBLIC">public</Select.Option>
            <Select.Option value="PRIVATE">Private</Select.Option>
            {/* <Select.Option value="SHARED-PUBLIC">Shared public</Select.Option>
          <Select.Option value="SHARED-PRIVATE">Shared private</Select.Option> */}
          </Select>
        </Form.Item>

        <Form.Item
          label="Overnight Charging Enabled"
          name="overNightChargingEnabled"
          rules={[{ required: true, message: "Please select nightChargering enabled or not!" }]}
        >
          <Select
            onClick={(e) => e.stopPropagation()}
            // value={locationDetails?.siteType}
            onChange={(value) => {
              setlocationDetails((prev) => ({
                ...prev,
                overNightChargingEnabled: value,
              }));
            }}
            placeholder="Select site type"
            value={locationDetails?.overNightChargingEnabled}
          >
            <Select.Option value={true}>True</Select.Option>
            <Select.Option value={false}>False</Select.Option>
            {/* <Select.Option value="SHARED-PUBLIC">Shared public</Select.Option>
          <Select.Option value="SHARED-PRIVATE">Shared private</Select.Option> */}
          </Select>
        </Form.Item>

        <Form.Item
          label="Property Voltage"
          name="propertyVoltage"
          rules={[{ required: true, message: "Please enter property voltage!" }]}
        >
          <InputNumber
            placeholder={210}
            min={0}
            // value={locationDetails?.latitude}
            onChange={(value) => {
              setlocationDetails((prev) => ({
                ...prev,
                propertyVoltage: value,
              }));
            }}
          />
        </Form.Item>

        <Form.Item
          label="Circuit Breaker Capacity"
          name="circuitBreakerCapacity"
          rules={[{ required: true, message: "Please enter circuit breaker capacity!" }]}
        >
          <InputNumber
            placeholder={60}
            min={0}
            // value={locationDetails?.latitude}
            onChange={(value) => {
              const calculatedAmp = value * 0.8;
              setlocationDetails((prev) => ({
                ...prev,
                circuitBreakerCapacity: value,
                currentChargerAmp: calculatedAmp,
              }));
              form.setFieldsValue({
                currentChargerAmp: calculatedAmp,
              });
            }}
          />
        </Form.Item>

        <Form.Item
          label="No of Chargers Sharing Breaker"
          name="noOfChargersSharingBreaker"
          rules={[{ required: true, message: "Please enter no of chargers sharing breaker!" }]}
        >
          <InputNumber
            placeholder={2}
            min={0}
            // value={locationDetails?.latitude}
            onChange={(value) => {
              setlocationDetails((prev) => ({
                ...prev,
                noOfChargersSharingBreaker: value,
              }));
            }}
          />
        </Form.Item>


        <Form.Item
          label="Charger Amp"
          name="currentChargerAmp"
          rules={[{ required: true, message: "Please enter charger amp!" }]}
        >
          <InputNumber
            placeholder={40}
            min={0}
            // value={locationDetails?.latitude}
            onChange={(value) => {
              setlocationDetails((prev) => ({
                ...prev,
                currentChargerAmp: value,
              }));
            }}
          />
        </Form.Item>


        <Form.Item
          label="Charger power"
          name="chargerPower"
        >
          <InputNumber
            placeholder={(locationDetails?.currentChargerAmp * locationDetails?.propertyVoltage)/1000}
            value={(locationDetails?.currentChargerAmp * locationDetails?.propertyVoltage)/1000}
            disabled
          />
        </Form.Item>




        {isApprover && isApproverView && <Form.Item className={Styles["full-width"]} name="isSectionCompleted" valuePropName="checked">
          <Checkbox
            disabled={
              Object.values(locationDetails).filter((value) => value !== null)
                .length /
              Object.values(locationDetails).length <
              1 || locationDetails?.isSectionCompleted
            }
            onChange={(e) => {
              //   setlocationDetails(prev => ({
              //     ...prev,
              //     isLocationSectionCompleted: e.target.checked
              // }));
              submitForm(e.target.checked);
            }}
          >
            {" "}
            Verified and Completed.
          </Checkbox>
        </Form.Item>}
      </Form>
    </div>
  );
};
export default LocationDetailsComponent;
